import * as React from 'react';
import { IconBase } from './icon-base.js';
export function CaretRight(iconProps) {
    return (React.createElement(IconBase, { name: 'caret-right', ...iconProps, render: ({ title, titleId, color, width, height, ...props }) => (React.createElement("svg", { width: width, height: height, viewBox: '0 0 16 16', fill: 'none', xmlns: 'http://www.w3.org/2000/svg', color: color, "aria-labelledby": titleId, ...props },
            title ? React.createElement("title", { id: titleId }, title) : null,
            React.createElement("path", { d: 'M6 3L11 8L6 13', stroke: 'currentColor', strokeWidth: 1.5, strokeLinecap: 'round', strokeLinejoin: 'round' }))) }));
}
